import { invoiceLogoPath, offerFileName, renderOfferPdf, type MoneyLocale, type SnapshotParty } from "@talentkontor/domain";
import { invoiceLogo } from "../../../model/invoice-document";
import { geltendeVorlage } from "../../../model/beleg-vorlagen";
import type { AnfrageDetail, OfferRow } from "./daten";
import { angebotPdfModell, type Talentlike } from "./model";

/**
 * Angebots-PDF im Browser erzeugen (wie das Mahnschreiben): dasselbe Modell wie die Ansicht, Logo und Farbe der Agentur.
 * Festgeschriebene Angebote nutzen die eingefrorenen Parteien, Entwürfe die aktuellen Stammdaten (mit „Entwurf“ im Kopf).
 */
export async function angebotPdf(d: AnfrageDetail, offer: OfferRow, ctx: {
  talents: readonly Talentlike[]; platformLabel: (key: string) => string; orgName: string; today: string; locale: string;
}): Promise<{ bytes: Uint8Array; filename: string }> {
  const issuer = (offer.issuer_snapshot as SnapshotParty | null) ?? { logo_path: typeof d.org?.logo_path === "string" ? d.org.logo_path : null };
  const logo = await invoiceLogo(invoiceLogoPath(issuer)).catch(() => null);
  const contact = d.contacts.find((c) => c.id === d.inquiry.contact_id)?.name ?? null;
  const model = angebotPdfModell({
    offer, lines: d.lines.filter((l) => l.offer_id === offer.id), candidates: d.candidates, inquiry: d.inquiry, talents: ctx.talents, platformLabel: ctx.platformLabel,
    org: d.org, legal: d.legal, brand: d.brand, contactName: contact, orgName: ctx.orgName, today: ctx.today,
    locale: (["de-DE", "de-AT", "de-CH", "en-GB"].includes(ctx.locale) ? ctx.locale : "de-DE") as MoneyLocale, logo: logo?.image ?? null,
  });
  const brand = typeof d.brand?.name === "string" ? d.brand.name : "Marke";
  // PDF-Vorlage für Angebote (0456): Marke vor Standard der Agentur
  const layout = await geltendeVorlage(d.inquiry.org_id, "offer", typeof d.brand?.id === "string" ? d.brand.id : null);
  return { bytes: renderOfferPdf(layout ? { ...model, layout } : model), filename: offerFileName(offer.number, brand, model.language) };
}
